<script setup>
import { computed } from "vue"
import DOMPurify from "dompurify"
import { marked } from "marked"

const props = defineProps({ content: { type: String, default: "" } })

marked.setOptions({ breaks: true, gfm: true })

const html = computed(() => DOMPurify.sanitize(marked.parse(props.content || ""), {
  ADD_ATTR: ["target", "rel"]
}).replaceAll("<a ", '<a target="_blank" rel="noopener noreferrer" '))
</script>

<template>
  <div class="chat-markdown" v-html="html"></div>
</template>
